(function (module) {
    "use strict";

    module.service("forecastProcessService", ['$http', forecastProcessService]);

    function forecastProcessService(this: $TSFixMe, $http: ng.IHttpService) {
        var service = this;

        service.sendToApproval = function (forecastId: $TSFixMe, budgetVersionUId: $TSFixMe, force = false) {
            return $http.post('/api/forecast/process/' + forecastId + '/send-to-approval/', {
                force,
                budgetVersionUId
            });
        }

        service.sendToApprovalAfterDefence = function (forecastId: $TSFixMe, jsonData: $TSFixMe, comment: $TSFixMe) {
            return $http({
                method: 'POST',
                url: '/api/forecast/process/' + forecastId + '/correction-after-defence',
                data: {
                    jsonData,
                    comment
                }
            });
        }

        service.approveCorrectionAfterDefence = function (forecastId: $TSFixMe) {
            return $http({
                method: 'POST',
                url: '/api/forecast/process/' + forecastId + '/approve-correction-after-defence'
            }).then(function (response: $TSFixMe) {
                return response.data;
            });
        }

        service.approve = function (forecastId: $TSFixMe) {
            return $http({
                method: 'POST',
                url: '/api/forecast/process/' + forecastId + '/approve'
            });
        }

        service.sendToCorrection = function (forecastId: $TSFixMe, comment: $TSFixMe) {
            return $http({
                method: 'POST',
                url: '/api/forecast/process/' + forecastId + '/send-to-correction',
                data: {
                    comment: comment
                }
            }).then(function (response: $TSFixMe) {
                return response.data;
            });
        }

        service.sendToCorrectionAfterDefence = function (forecastId: $TSFixMe, comment: $TSFixMe) {
            return $http({
                method: 'POST',
                url: '/api/forecast/process/' + forecastId + '/send-to-correction-after-defence',
                data: {
                    comment: comment
                }
            }).then(function (response: $TSFixMe) {
                return response.data;
            });
        }

        service.cancelForecastCorrectionAfterDefence = function (forecastId: $TSFixMe) {
            return $http({
                method: 'POST',
                url: '/api/forecast/process/' + forecastId + '/cancel-correction-after-defence'
            }).then(function (response: $TSFixMe) {
                return response.data;
            });
        }

        service.removeForecastCorrectionAfterDefence = function (forecastId: $TSFixMe) {
            return $http({
                method: 'POST',
                url: '/api/forecast/process/' + forecastId + '/remove-correction-after-defence'
            }).then(function (response: $TSFixMe) {
                return response.data;
            });
        }

        service.enlist = (forecastId: $TSFixMe) => {
            return $http({
                method: 'POST',
                url: '/api/forecast/process/' + forecastId + '/enlist'
            });
        }

        service.delist = (forecastId: $TSFixMe) => {
            return $http({
                method: 'POST',
                url: '/api/forecast/process/' + forecastId + '/delist'
            });
        }

        service.changeProductManager = (forecastId: $TSFixMe, productManagerMsnuId: $TSFixMe) =>
            $http.post('/api/forecast/process/product-manager', {
                forecastId,
                productManagerMsnuId
            });

        service.changeProductCodes = (changes: $TSFixMe) => {
            return $http.post('/api/forecast/changeProductCodes', {
                changes
            });
        }
    }


})(angular.module('topline.services'));